"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customPropTypes = require("../../helpers/customPropTypes");

var _tokens = require("../../helpers/tokens.json");

var _tokens2 = _interopRequireDefault(_tokens);

var _Icon = require("../../Icon");

var _Icon2 = _interopRequireDefault(_Icon);

require("./ErrorMessage.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var iconSize = {
  small: 13,
  medium: 14,
  large: 16
};

var ErrorMessage = function ErrorMessage(_ref) {
  var children = _ref.children,
      isHTML = _ref.isHTML,
      size = _ref.size,
      moreProps = _objectWithoutProperties(_ref, ["children", "isHTML", "size"]);

  if (!children) return null;

  return _react2.default.createElement(
    "div",
    _extends({ className: "aclui-form-error", role: "alert" }, moreProps),
    _react2.default.createElement(_Icon2.default, { type: "exclamation-circle", color: _tokens2.default.color.orange, size: iconSize[size] }),
    isHTML ? _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: children } }) : children
  );
};

ErrorMessage.propTypes = {
  children: _propTypes2.default.node,
  isHTML: _propTypes2.default.bool,
  size: _customPropTypes.shirtSize
};

ErrorMessage.defaultProps = {
  children: null,
  isHTML: false,
  size: "medium"
};

exports.default = ErrorMessage;